<template>
    <ion-page>
        <ion-segment v-model="activeTab" @ionChange="resetPagination">
            <ion-segment-button value="user">
                <ion-label>User Report</ion-label>
            </ion-segment-button>

            <ion-segment-button value="invoice">
                <ion-label>Invoice Report</ion-label>
            </ion-segment-button>

            <ion-segment-button value="usage">
                <ion-label>Usage Report</ion-label>
            </ion-segment-button>
        </ion-segment>

        <ion-content class="ion-padding">
            <section v-if="activeTab === 'user'">
                <ion-grid>
                    <ion-row class="search-view">
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">
                                From Date
                            </ion-label>
                            <div class="date-picker-box margin-top-10 datepicker-web">
                                <datepicker
                                    class="form-vue-picker"
                                    placeholder="DD/MON/YYYY"
                                    inputFormat="dd/MMM/yyyy"
                                    v-model="fromDate"
                                    :typeable="true"
                                    :lowerLimit ="sixMonthsAgo"
                                    :upperLimit ="currentDate"
                                ></datepicker>
                                <span class="custom-calendar-icon">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                            <div class="border-line-34 margin-top-10 datepicker-mobile">
                                <datepicker
                                    class= "form-picker"
                                    placeholder= "Select From Date"
                                    inputFormat="MMM dd, yyyy"
                                    v-model="fromDate"
                                    :typeable= "true"
                                    :lowerLimit ="sixMonthsAgo"
                                    :upperLimit ="currentDate"
                                ></datepicker>
                                <span class="input-icon-calendar">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">
                                To Date
                            </ion-label>
                            <div class="date-picker-box margin-top-10 datepicker-web">
                                <datepicker
                                    class="form-vue-picker"
                                    placeholder="DD/MON/YYYY"
                                    inputFormat="dd/MMM/yyyy"
                                    v-model="toDate"
                                    :typeable="true"
                                    :lowerLimit ="sixMonthsAgo"
                                    :upperLimit ="currentDate"
                                ></datepicker>
                                <span class="custom-calendar-icon">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                            <div class="border-line-34 margin-top-10 datepicker-mobile">
                                <datepicker
                                class= "form-picker"
                                placeholder= "Select To Date"
                                inputFormat="MMM dd, yyyy"
                                v-model="toDate"
                                :typeable= "true"
                                :value = toDate   
                                :lowerLimit ="sixMonthsAgo"
                                :upperLimit ="currentDate"
                                ></datepicker>
                                <span class="input-icon-calendar">
                                <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="6">
                            <br />
                            <ion-button class="btn-search margin-top-10" @click="searchUserReport">Search</ion-button>
                            <ion-button class="btn-clear margin-top-10" @click="clearFields">
                                <ion-icon :icon="refresh"></ion-icon>
                            </ion-button>
                            <ion-button v-if="userReportList && userReportList.length > 0" class="btn-search margin-top-10" @click="downloadReport(reportResult,'UserReport')">
                                Download Report
                            </ion-button>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col size="4"></ion-col>
                        <ion-col size="4">
                            <!-- <ion-button class="btn-export" @click="downloadCSV(result)">
                                Download Report
                            </ion-button> -->
                        </ion-col>
                    </ion-row>
                    <br>
                    <ion-row class="row-divider"></ion-row>
                    <ion-row class="list-view">
                        <ion-col>
                            <ion-row class="list-head">
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>Display Name</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>Cus.No</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>First Name</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>Last Name</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>GST Treatment</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>GST Identification Number (GSTIN)</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>Email ID</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>Mobile</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>Billing State</ion-label>
                                </ion-col>
                            </ion-row>
                            <hr />
                            <ion-row class="list-item" v-for="(value,index) in userReportList" :key="index">
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>{{ value.displayName  }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>{{ value.customerNumber }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>{{ value.firstName }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>{{ value.lastName }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>{{ value.gstTreatment }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>{{ value.gstNumber }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>{{ value.emailId }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>{{ value.mobile }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>{{ value.billingState }}</ion-label>
                                </ion-col>
                            </ion-row>
                        </ion-col>
                    </ion-row>
                </ion-grid>
                <ion-row v-if="norecordsfound">
                    <ion-col size="12" class="pagination-info">
                    <ion-label class="pagination-info">No records found for the selected filters</ion-label>
                    </ion-col>
                </ion-row>
                <ion-row v-else>
                    <ion-col size="12" size-md="5">
                    <ion-label
                        class="pagination-info"
                    >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="7" class="ion-text-right">
                    <div class="pagination">
                        <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
                        <a class="prev disabled" v-else>Prev</a>
                        <a
                        
                        v-for="page in this.pagesList"
                        :key="page"
                        v-bind:class="{'active': pageNo == page}"
                        @click="loadPage(page)"
                        >{{page}}</a>
                        <a
                        
                        class="next"
                        v-if="this.pageNo < this.totalPages"
                        @click="loadPage(pageNo + 1)"
                        >Next</a>
                        <a class="next disabled" v-else>Next</a>
                    </div>
                    </ion-col>
                </ion-row>
            </section>

            <section v-if="activeTab === 'invoice'">
                <ion-grid>
                    <ion-row class="search-view">
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">
                                From Date
                            </ion-label>
                            <div class="date-picker-box margin-top-10 datepicker-web">
                                <datepicker
                                    class="form-vue-picker"
                                    placeholder="DD/MON/YYYY"
                                    inputFormat="dd/MMM/yyyy"
                                    v-model="fromDate"
                                    :typeable="true"
                                    :lowerLimit ="sixMonthsAgo"
                                    :upperLimit ="currentDate"
                                ></datepicker>
                                <span class="custom-calendar-icon">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                            <div class="border-line-34 margin-top-10 datepicker-mobile">
                                <datepicker
                                    class= "form-picker"
                                    placeholder= "Select From Date"
                                    inputFormat="MMM dd, yyyy"
                                    v-model="fromDate"
                                    :typeable= "true"
                                    :lowerLimit ="sixMonthsAgo"
                                    :upperLimit ="currentDate"
                                ></datepicker>
                                <span class="input-icon-calendar">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">
                                To Date
                            </ion-label>
                            <div class="date-picker-box margin-top-10 datepicker-web">
                                <datepicker
                                    class="form-vue-picker"
                                    placeholder="DD/MON/YYYY"
                                    inputFormat="dd/MMM/yyyy"
                                    v-model="toDate"
                                    :typeable="true"
                                    :lowerLimit ="sixMonthsAgo"
                                    :upperLimit ="currentDate"
                                ></datepicker>
                                <span class="custom-calendar-icon">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                            <div class="border-line-34 margin-top-10 datepicker-mobile">
                                <datepicker
                                class= "form-picker"
                                placeholder= "Select To Date"
                                inputFormat="MMM dd, yyyy"
                                v-model="toDate"
                                :typeable= "true"
                                :lowerLimit ="sixMonthsAgo"
                                :upperLimit ="currentDate"
                                ></datepicker>
                                <span class="input-icon-calendar">
                                <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <br />
                            <ion-button class="btn-search margin-top-10" @click="invoiceReport">Search</ion-button>
                            <ion-button class="btn-clear margin-top-10" @click="clearFields">
                                <ion-icon :icon="refresh"></ion-icon>
                            </ion-button>
                            <ion-button v-if="incoiceReportList && incoiceReportList.length > 0" class="btn-search margin-top-10" @click="downloadReport(invoiceResult,'InvoiceReport')">
                                Download Report
                            </ion-button>
                        </ion-col>
                    </ion-row>
                    <br>
                    <ion-row class="row-divider"></ion-row>
                    <ion-row class="list-view">
                        <ion-col>
                            <ion-row class="list-head">
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>Inv.no</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>Inv.Date</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>Cus.Name</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>Cus.No</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>GST Treatment</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>GST Identification Number (GSTIN)</ion-label>
                                </ion-col>
                                <!-- <ion-col size="12" size-md="1.5">
                                    <ion-label>Place of supply</ion-label>
                                </ion-col> -->
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>Station Name</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>Quantity</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>Price</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>Inv.Total</ion-label>
                                </ion-col>
                            </ion-row>
                            <hr />
                            <ion-row class="list-item" v-for="(value,index) in incoiceReportList" :key="index">
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>{{ value.invoiceNumber  }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>{{ changeDateFormatWithoutTime(value.invoiceDate) }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>{{ value.customerName }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>{{ value.customerNumber }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>{{ value.gstTreatment }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>{{ value.gstNumber }}</ion-label>
                                </ion-col>
                                <!-- <ion-col size="12" size-md="1.5">
                                    <ion-label>{{  }}</ion-label>
                                </ion-col> -->
                                <ion-col size="12" size-md="1.5">
                                    <ion-label>{{ value.stationName }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>{{ value.quantity }}</ion-label>
                                </ion-col>
                                
                                <ion-col size="12" size-md="1">
                                    <ion-label>{{ value.itemPrice }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>{{ value.itemTotal }}</ion-label>
                                </ion-col>
                            </ion-row>
                        </ion-col>
                    </ion-row>
                </ion-grid>
                <ion-row v-if="norecordsfound">
                    <ion-col size="12" class="pagination-info">
                    <ion-label class="pagination-info">No records found for the selected filters</ion-label>
                    </ion-col>
                </ion-row>
                <ion-row v-else>
                    <ion-col size="12" size-md="5">
                    <ion-label
                        class="pagination-info"
                    >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="7" class="ion-text-right">
                    <div class="pagination">
                        <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
                        <a class="prev disabled" v-else>Prev</a>
                        <a
                        
                        v-for="page in this.pagesList"
                        :key="page"
                        v-bind:class="{'active': pageNo == page}"
                        @click="loadPage(page)"
                        >{{page}}</a>
                        <a
                        
                        class="next"
                        v-if="this.pageNo < this.totalPages"
                        @click="loadPage(pageNo + 1)"
                        >Next</a>
                        <a class="next disabled" v-else>Next</a>
                    </div>
                    </ion-col>
                </ion-row>
            </section>

            <section v-if="activeTab === 'usage'">
                <ion-grid>
                    <ion-row class="search-view">
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">
                                To Date
                            </ion-label>
                            <div class="date-picker-box margin-top-10 datepicker-web">
                                <datepicker
                                    class="form-vue-picker"
                                    placeholder="DD/MON/YYYY"
                                    inputFormat="dd/MMM/yyyy"
                                    v-model="toDate"
                                    :typeable="true"
                                ></datepicker>
                                <span class="custom-calendar-icon">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                            <div class="border-line-34 margin-top-10 datepicker-mobile">
                                <datepicker
                                class= "form-picker"
                                placeholder= "Select To Date"
                                inputFormat="MMM dd, yyyy"
                                v-model="toDate"
                                :typeable= "true"
                                ></datepicker>
                                <span class="input-icon-calendar">
                                <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <br />
                            <ion-button class="btn-search margin-top-10" @click="usageReport">Search</ion-button>
                            <ion-button class="btn-clear margin-top-10" @click="clearFields">
                                <ion-icon :icon="refresh"></ion-icon>
                            </ion-button>
                            <ion-button v-if="usageReportList && usageReportList.length > 0" class="btn-search margin-top-10" @click="downloadReport(usageResult,'UsageReport')">
                                Download Report
                            </ion-button>
                        </ion-col>
                    </ion-row>
                    <br>
                    <ion-row class="row-divider"></ion-row>
                    <ion-row class="list-view">
                        <ion-col>
                            <ion-row class="list-head">
                                <ion-col size="12" size-md="0.5">
                                    <ion-label>ID</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>Mobile</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>First Name</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>Last Name</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>Email</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>Effective From</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.3">
                                    <ion-label>Total Topup Amount</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.3">
                                    <ion-label>Last month Amount was</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.3">
                                    <ion-label>Total Amount Spend</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.3">
                                    <ion-label>Total Transaction</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.3">
                                    <ion-label>Consumed Unit</ion-label>
                                </ion-col>
                            </ion-row>
                            <hr />
                            <ion-row class="list-item" v-for="(value,index) in usageReportList" :key="index">
                                <ion-col size="12" size-md="0.5">
                                    <ion-label>{{ value.userId  }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>{{ value.mobile }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>{{ value.firstName }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>{{ value.lastName }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>{{ value.email }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1">
                                    <ion-label>{{ changeDateFormatWithoutTime(value.effectivefrom) }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.3">
                                    <ion-label>{{ value.totalTopupAmount }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.3">
                                    <ion-label>{{ value.lastMonthAmountWas }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.3">
                                    <ion-label>{{ value.totalAmountSpent }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.3">
                                    <ion-label>{{ value.totalTransactions }}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="1.3">
                                    <ion-label>{{ value.totalTransactions }}</ion-label>
                                </ion-col>
                            </ion-row>
                        </ion-col>
                    </ion-row>
                </ion-grid>
                <ion-row class="row-divider"></ion-row>
                <ion-row v-if="norecordsfound">
                    <ion-col size="12" class="pagination-info">
                    <ion-label class="pagination-info">No records found for the selected filters</ion-label>
                    </ion-col>
                </ion-row>
                <ion-row v-else>
                    <ion-col size="12" size-md="5">
                    <ion-label
                        class="pagination-info"
                    >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="7" class="ion-text-right">
                    <div class="pagination">
                        <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
                        <a class="prev disabled" v-else>Prev</a>
                        <a
                        
                        v-for="page in this.pagesList"
                        :key="page"
                        v-bind:class="{'active': pageNo == page}"
                        @click="loadPage(page)"
                        >{{page}}</a>
                        <a
                        
                        class="next"
                        v-if="this.pageNo < this.totalPages"
                        @click="loadPage(pageNo + 1)"
                        >Next</a>
                        <a class="next disabled" v-else>Next</a>
                    </div>
                    </ion-col>
                </ion-row>
            </section>
        </ion-content>
        
    </ion-page>
    <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-loading :is-open="isLoading" class="custom-loading" spinner="lines-sharp" message="Please Wait..." v-if="isLoading"></ion-loading>
                </ion-col>
            </ion-row>
        </ion-grid>
</template>

<script>
import { defineComponent } from "vue";
import { refresh } from 'ionicons/icons';
import datepicker from 'vue3-datepicker';
import { AdminService } from "@/service/admin/admin.service";
import { migratedTryParseServiceError } from "../../service";
import { CorporateService } from "../../service/corporate/corporate.service";
import moment from "moment";
import { ToastUtils } from "../../util/toast-utils";
import { PaginationUtils } from "../../util/pagination-utils";
import jsonToCsvExport from "json-to-csv-export";
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonSegment, IonSegmentButton, IonLabel, IonGrid, IonRow, IonCol, IonLoading } from "@ionic/vue";

export default defineComponent({
  name: "ViewAllReport",
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonSegment,
    IonSegmentButton,
    IonLabel,
    IonGrid,
    IonRow,
    IonCol,
    datepicker,
    IonLoading
  },
  data() {
    return {
        isLoading: false,
        refresh,
        activeTab: "user",
        fromDate: new Date(),
        toDate: new Date(),
        configDays: 0,
        configMonths: 0,
        maxDate: new Date(), 
        currentDate: new Date(),
        sixMonthsAgo: new Date(),
        reportResult: null,
        totalRecords: 0,
        pageRecords: 10,
        pageNo: 1,
        pagesList: [],
        totalPages: 0,
        norecordsfound: true,
        invoiceResult: null,
         userReportList: [],
        incoiceReportList: [],
        usageResult: null,
        usageReportList: [],
        filteredData: ""

    };
  },

  async mounted() {
        await this.getDateAndMonth()
        await this.getDateDaysAgo(this.configDays)
        await this.getDateMonthsAgo(this.configMonths)
    },

  methods: {
    async resetPagination() {
        this.totalRecords = 0;
        this.pageNo = 1;
        this.pagesList = [];
        this.totalPages = 0;
        this.filteredData = [];
        this.norecordsfound = true;
        await this.getDateAndMonth()
        await this.getDateDaysAgo(this.configDays)
        await this.getDateMonthsAgo(this.configMonths)
        this.toDate = new Date();

        this.userReportList = [];
        this.incoiceReportList = [];
        this.usageReportList = [];
    },
    changeDateFormatWithoutTime(dateValue) {
        if(dateValue != null) {
            return moment(dateValue).format('DD/MMM/YYYY')
        }
    },
    async getDateAndMonth() {
        this.configValue = await new CorporateService().getConfigValueOfDateAndMonth()
        this.configDays = this.configValue[0].description;
        this.configMonths = this.configValue[1].description
    },

    async getDateDaysAgo(days) {
        const date = new Date();
        date.setDate(date.getDate() - days);

        this.fromDate =  date;
    },
    async getDateMonthsAgo(months) {
        const date = new Date();
        date.setMonth(date.getMonth() - months);
        this.sixMonthsAgo = date;
    },

    

    async searchUserReport(){
        try{
            let result = await new AdminService().customerReport({
                fromDate: moment(this.fromDate).format('YYYY-MM-DD'),
                toDate: moment(this.toDate).format('YYYY-MM-DD')
            });
            this.reportResult = result;
            this.filteredData = result.downloadingReportData.csv;

            this.totalRecords = this.filteredData.length;

            this.pagesList = new PaginationUtils().getPagesList(
                this.totalRecords,
                this.pageRecords,
                this.pageNo
            );

            this.totalPages = new PaginationUtils().getTotalPages(
                this.totalRecords,
                this.pageRecords
            );

            const pageData = { recordNumber: 0, records: 9999999999 };

            try {

                pageData.records = parseInt(this.pageRecords);
                pageData.recordNumber = parseInt(
                    pageData.records * (this.pageNo - 1)
                );

                this.userReportList = this.filteredData.slice(
                    pageData.recordNumber,
                    (pageData.records * this.pageNo)
                );

                this.norecordsfound = false;

            } catch (error) {
                console.log("Pagination Error:", error);
            }

            if(result?.data.success) {
                new ToastUtils().presentToast(result.data.message);
            }

        }catch(error) {
            this.loaderTab = false;
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        }

    },

    async invoiceReport() {
        try{

            let result = await new AdminService().invoiceReport({
                fromDate: moment(this.fromDate).format('YYYY-MM-DD'),
                toDate: moment(this.toDate).format('YYYY-MM-DD')
            });
            this.invoiceResult = result;
            this.filteredData = result.downloadingReportData.csv;

            this.totalRecords = this.filteredData.length;

            this.pagesList = new PaginationUtils().getPagesList(
                this.totalRecords,
                this.pageRecords,
                this.pageNo
            );

            this.totalPages = new PaginationUtils().getTotalPages(
                this.totalRecords,
                this.pageRecords
            );

            const pageData = { recordNumber: 0, records: 9999999999 };

            try {

                pageData.records = parseInt(this.pageRecords);
                pageData.recordNumber = parseInt(
                    pageData.records * (this.pageNo - 1)
                );

                this.incoiceReportList = this.filteredData.slice(
                    pageData.recordNumber,
                    (pageData.records * this.pageNo)
                );

                this.norecordsfound = false;

            } catch (error) {
                console.log("Pagination Error:", error);
            }

            if(result?.data.success) {
                new ToastUtils().presentToast(result.data.message);
            }

        }catch(error) {
            this.loaderTab = false;
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        }
    },

    async usageReport() {
        try{
            this.isLoading = true;
            let result = await new AdminService().usageReport({
                toDate: moment(this.toDate).format('YYYY-MM-DD')
            });
            this.isLoading = false;
            this.usageResult = result;
            this.filteredData = result.downloadingReportData.csv;

            this.totalRecords = this.filteredData.length;

            this.pagesList = new PaginationUtils().getPagesList(
                this.totalRecords,
                this.pageRecords,
                this.pageNo
            );

            this.totalPages = new PaginationUtils().getTotalPages(
                this.totalRecords,
                this.pageRecords
            );

            const pageData = { recordNumber: 0, records: 9999999999 };

            try {

                pageData.records = parseInt(this.pageRecords);
                pageData.recordNumber = parseInt(
                    pageData.records * (this.pageNo - 1)
                );

                this.usageReportList = this.filteredData.slice(
                    pageData.recordNumber,
                    (pageData.records * this.pageNo)
                );

                this.norecordsfound = false;

            } catch (error) {
                console.log("Pagination Error:", error);
            }

            if(result?.data.success) {
                new ToastUtils().presentToast(result.data.message);
            }

        }catch(error) {
            this.loaderTab = false;
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        }
    },

    downloadReport(reportData, fileName) {
        try {
            jsonToCsvExport({
                data: reportData.downloadingReportData.csv,
                headers: reportData.reportHeaders.csvHeader,
                filename: fileName + "_" + moment().format("DD-MM-YYYY") + ".csv"
            });

        } catch (error) {
            console.error("Error generating CSV:", error);
        }
    },

    loadPage(page){

        this.pageNo = page;
        this.pagesList = new PaginationUtils().getPagesList(
            this.totalRecords,
            this.pageRecords,
            this.pageNo
        );

        const pageData = { recordNumber: 0, records: 9999999999 };

        pageData.records = parseInt(this.pageRecords);
        pageData.recordNumber = parseInt(
            pageData.records * (this.pageNo - 1)
        );

        if(this.activeTab === "user"){
            this.userReportList = this.filteredData.slice(
                pageData.recordNumber,
                (pageData.records * this.pageNo)
            );
        }

        if(this.activeTab === "invoice"){
            this.incoiceReportList = this.filteredData.slice(
                pageData.recordNumber,
                (pageData.records * this.pageNo)
            );
        }

        if(this.activeTab === "usage"){
            this.usageReportList = this.filteredData.slice(
                pageData.recordNumber,
                (pageData.records * this.pageNo)
            );
        }
    },

    async clearFields() {
        await this.getDateDaysAgo(this.configDays);
        this.toDate = new Date();
        await this.getDateMonthsAgo(this.configMonths);
        this.userReportList = [];
        this.incoiceReportList = [];
        this.usageReportList = [];
        this.norecordsfound = true;
    }
  }
});
</script>

<style scoped>
ion-segment {
  border-radius: 8px;
  padding: 4px;
  margin-top: 10px;
  --background: #f4f6f8;
}

ion-segment-button {
  --background: transparent;
  --color: #333;
}

ion-segment-button::part(native),
ion-segment-button:hover::part(native),
ion-segment-button:focus::part(native),
ion-segment-button:active::part(native) {
  color: #333;
}

ion-segment-button.segment-button-checked::part(native) {
  background: #099c14;
  color: #ffffff;
  border-radius: 8px;
}

ion-segment-button.segment-button-checked:hover::part(native),
ion-segment-button.segment-button-checked:focus::part(native) {
  background: #099c14;
  color: #ffffff;
}

ion-segment-button {
  --indicator-color: transparent;
  --indicator-height: 0px;
}

</style>
